import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: 200px;
  width: 640px;

  @media (max-width: 768px) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border: 0px solid ${({ theme }) => theme.colors.GREY_HEAVY};
  border-radius: 12px;
  min-height: 131px;
  width: 100%;
  box-sizing: border-box;
`;

// export const Card = styled.div`
//   display: flex;
//   flex-direction: column;
//   border: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`};
//   border-radius: 8px;
//   background-color: ${({ theme }) => theme.colors.WHITE};
//   min-height: 131px;
//   width: 640px;
//     @media (max-width: 768px) {
//         width: 100%;
//     }
//   padding: 24px;
//   box-sizing: border-box;
//   gap: 16px;
// `;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 0px solid #ececec;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  min-height: 80px;
  padding: 20px 20px 30px 20px;
  box-sizing: border-box;
  width: 640px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TitleHighlight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  min-width: 100%;
  width: 100%;
  height: 10px;
  z-index: 20;
`;

export const ResultContainer = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  justify-content: center;
  margin: 6px 10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
`;

export const ResultTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const ResultTitle = styled.span`
  font-size: 24px;
`;

export const ResultType = styled.span`
  font-size: 12px;
  background-color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  color: ${({ theme }) => theme.colors.WHITE};
  padding: 6px;
  border-radius: 4px;
`;

export const ResultAnswerSection = styled.div`
  // display: flex;
  // flex-direction: column;
  // gap: 16px;
  width: 100%;

  font-size: 14px;
  background-color: #f7f9fd;
  padding: 15px 20px;
  border-radius: 6px;
`;

export const NoTextAnswer = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.RED};
`;

export const TextAnswer = styled.div`
  font-size: 16px;
  margin: 5px 0;
  white-space: pre-line;
`;

export const UrlAnswer = styled.div`
  font-size: 16px;
  margin: 5px 0;
  font-weight: bold;
`;

export const ListAnswer = styled.li`
  font-size: 16px;
  margin: 5px 0;
  word-break: break-all;
`;

export const Url = styled.a`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  margin: 5px 0;
`;

export const SectionTitle = styled.div`
  // background-color: ${({ theme }) => theme.colors.WHITE};
  display: flex;
  width: 100%;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.BLACK};
  padding: 50px 0 0 10px;
  font-weight: bold;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;
`;

export const TitleSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Title = styled.span`
  padding: 8px 0 8px 3px;
  font-size: 18px;
  font-weight: bold;
`;

export const NeedLogin = styled.span`
  padding: 8px;
  font-size: 16px;
  word-break: break-word;
  display: inline-block;
  color: ${({ theme }) => theme.colors.RED};
  font-weight: bold;
`;

export const RequireMark = styled.span`
  padding-left: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.RED};
`;

export const NoticeTitle = styled.div`
  font-size: 13px;
  margin-top: 8px;
  margin-bottom: 0px;
  padding: 0 8px;
  line-height: 1.5;
`;

export const RequiredSection = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 30px;
`;

export const RequiredSpan = styled.span`
  font-size: 12px;
  padding-left: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.RED};
`;
